import { ImageScanOverlay } from '../ImageScanOverlay';
import type {
  ImageSearchResultType,
  PhotoCardResultType,
  ImageSearchResponseType
} from '../../types/type';
import CenterScreenWrapper from '../CenterScreenWrapper';
import { t } from 'i18next';
import { ThumbnailPhotoCard } from '@peacecover/component';
import plusCircleHollow from '../../../../icons/plus.circle.outline.svg';
import { Trans } from 'react-i18next';

export default function ImageSearchResultDetail({
  selectedMember,
  searchResult,
  onCardClick,
  onBackClick
}: {
  selectedMember: ImageSearchResultType['selectedMember'];
  searchResult: ImageSearchResponseType['results'][number];
  onCardClick: ({ position, photoCardId }: { position: number; photoCardId: string }) => void;
  onBackClick: () => void;
}) {

  return (
    <CenterScreenWrapper
      onBackClick={onBackClick}
      topNavigationTitle={t('imageSearch.searchResult.topNavigationTitle') as string}
    >
      {/* 요소들 px단위로 수정 하기 위한 컨테이너 */}
      <div className="h-full flex flex-col items-center">
        <div className="mt-[36px] mb-[7px]">
          <ImageScanOverlay
            imageData={searchResult.originalUrl}
            selectedMember={selectedMember}
            isLoading={true}
            size="sm"
          />
        </div>
        <div className="flex flex-col items-center gap-[14px] py-[10px] mb-[22px] px-[24px]">
          <p className="text-pure-black text-[26px] font-bold dark:text-main-dark-1 text-center leading-tight">
            <span className="block">{t('imageSearch.success.title')}</span>
          </p>
          <p className="text-main-light-4 text-[15px] font-medium dark:text-main-dark-4">
            {t('imageSearch.success.description')}
          </p>
        </div>
        <ImageSearchResultList
          results={searchResult.candidates.slice(0, 6)}
          onCardClick={(photoCardId: string) => {
            onCardClick({ position: searchResult.position, photoCardId });
          }}
        />
        <p className="text-main-light-4 text-[12px] font-normal dark:text-main-dark-4 text-center mt-[32px] px-[24px]">
          <Trans
            i18nKey="imageSearch.success.bottomDescription"
            components={{
              strong: <span className="font-bold text-main-strong" />
            }}
          />
        </p>
      </div>
    </CenterScreenWrapper>
  );
}

const ImageSearchResultList = ({
  results,
  onCardClick
}: {
  results: PhotoCardResultType[];
  onCardClick: (photoCardId: string) => void;
}) => {
  return (
    <div className="grid grid-cols-3 gap-[2.24px] w-fit mx-auto">
      {results.map((result, index) => {
        const rotationClass = index % 2 === 0 ? 'rotate-[-2.807deg]' : 'rotate-[1.369deg]';
        return (
          <ImageSearchResultCardWrapper
            key={result.photoCard?.photoCardId}
            rotationClass={rotationClass}
            onClick={() => onCardClick(result.photoCard?.photoCardId ?? '')}
          >
            <ThumbnailPhotoCard imageUrl={result.pictureUrl} className="w-[83px] h-[131px]" />
          </ImageSearchResultCardWrapper>
        );
      })}
    </div>
  );
};


//포카 등록하기 카드 컴포넌트
//그라데이션 컬러 카드 + 버튼, 직접 추가하기 텍스트 표시
export const ImageAddCard = ({ onAddCard }: { onAddCard: () => void }) => {
  return (
    <ImageSearchResultCardWrapper rotationClass="rotate-[2.369deg]" onClick={onAddCard}>
      <div className="relative w-[83px] h-[131px] rounded-[10.08px] overflow-hidden">
        <div className="absolute inset-0 bg-white z-0" />
        <div
          className="absolute inset-0 z-10 flex items-center justify-center gap-[8px] flex-col text-center"
          style={{
            backgroundImage:
              'linear-gradient(136deg, rgba(21, 204, 203, 0.71) 1.21%, rgba(73, 135, 255, 0.71) 50.69%, rgba(139, 28, 250, 0.71) 101.7%)'
          }}
        >
          <img src={plusCircleHollow} alt="plus" />
          <p className="text-pure-white text-[15px] font-semibold whitespace-pre-line leading-tight">
            {t('imageSearch.success.add')}
          </p>
        </div>
      </div>
    </ImageSearchResultCardWrapper>
  );
};

const ImageSearchResultCardWrapper = ({
  children,
  rotationClass,
  onClick
}: {
  children: React.ReactNode;
  rotationClass: string;
  onClick: () => void;
}) => {
  return (
    <button
      type="button"
      className={`w-[99px] h-[147px] flex flex-col items-center justify-center rounded-[11px] border border-surface-lightLv2 bg-pure-white dark:bg-pure-black shadow-[0_2.52px_5.04px_0_rgba(0,0,0,0.05)] ${rotationClass}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
